import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { toast } from 'react-toastify';
import getCroppedImage from '../../../Util/getCroppedImage';
import IconCropper from '../../../components/IconCropper/iconCropper';
import { useMutation } from 'react-query';
import { updateWebSite } from '../../../services/websitesService';
import { useAppContext } from '../../../appProvider/contextProvider';
import { ERRORS } from '../../../constants/AppConstants';


const ChangeIcon = () => {

    const history = useHistory();
    const {state: website} = useLocation();

    const {updateWebsites,
        isDirty,
        setIsDirty,
        setPathToNavigate,
        setDiscardPromptOpen
    }= useAppContext();

    const [logo, setWebsiteLogo] = useState(website.logo || null);
    const [logoName, setLogoName] = useState(website.logo ? 'logo.png' : '');
    const [imagePath, setIconPath] = useState(website.logo || '');
    const [openCropper, setOpenCropper] = useState(false);


    const handelFileUpload = (({target}) => {
        
        if(target.files && target.files[0]) {
            setIsDirty(true);
            const url = URL.createObjectURL(target.files[0]);
            setLogoName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);

        }
    });


    const onCancelCrop = () => {
        setIconPath(imagePath);
        setOpenCropper(false);
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            imagePath,
            croppedAreaPixel,
            0,
            logoName,
        );
        setIconPath(url);
        setWebsiteLogo(file);
        setOpenCropper(false);
    }

    const onSave = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('logo', logo);
        updateWeb.mutate(formData)
    }

    const updateWeb = useMutation((formData) => {
        return updateWebSite(formData, website.id)
    }, {
        onSuccess: ((webSiteData) => {
            if(webSiteData.errors && webSiteData.errors.logo && webSiteData.errors.logo.length > 0) {
                toast.error(ERRORS[webSiteData.errors.logo[0]]);
            } else {
                setIsDirty(false);
                updateWebsites(webSiteData);
                toast.success('Icon has been successfully changed.');
                history.push('/websites-setup');
            }
        }),
        onError: ((error) => {
            console.log(error);
        })
    });

    const isUpdateDisables = () => typeof logo === 'string' || !logo;

    const onBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/websites-setup');
        } else {
            history.goBack();
        }
    }

    const getImagePath = () => {
        if(imagePath.startsWith('https://')) {
            return `${imagePath}?${new Date().getTime()}`
        }
        return imagePath;
    }

    return <> 
        <div className="row">
            <div className="col-12 col-lg-6 mb-4">
                <div className="panel full-height">
                    <div className="panel-header">
                        <div className="d-flex flex-wrap align-items-center">
                            <h3 className="mb-0 regular">
                                <i className="icon icon-chevron-left mr-2" onClick={onBack} ></i> Change Icon for 
                            </h3>
                            <span className="ml-2"><b>{website.url}</b></span>
                        </div>                                
                    </div>
                    <div className="panel-body scrollable_y">
                        <p className="mb-2 text-grey">Please upload an icon that you wish to appear together with each notification. Usually your site icon.
                            Ideally square. And colorful. And recognizable...</p>
                        <div className="form-group">
                            <label className="form-label text-dark medium">File</label>
                            <div className="d-flex align-items-center">
                                <div className="file-upload">                                
                                    <input
                                        type="file"
                                        className=""
                                        accept="image/*"
                                        onChange={(event) => handelFileUpload(event)}
                                    /><i className="icon icon-file"></i>
                                    Select File                                
                                </div>         
                                {logo && <span className="ml-2">{logoName}</span>}                                   
                            </div>
                            <p className="text-grey"><small>Upload the logo for your website. It will appear inside the Push Notification received by your
                                readers. We will generate all the required sizes. Ideally, the image you upload is square.</small></p>
                        </div>
                        <button className="btn btn-sm btn-primary" disabled={isUpdateDisables()} onClick={onSave} >Save</button>
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-6 mb-4">
            <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Preview</h3>
                    </div>                                
                </div>
                <div className="panel-body full-height">
                    <div className="d-flex justify-content-center align-items-center full-height">
                        <div className="box">
                            <div className="media align-items-center p-1">
                                <div className="media_figure media-rounded media-sm">
                                    {/* Add image Tah */}
                                {/* <h3 className="abbr">C</h3> */}
                                <img src={getImagePath()} style={{height:'40px', width:'40px'}} />
                                </div>
                                <div className="media_body text-grey">
                                    <h6 className="mb-0">Something cool will launch</h6>
                                    <p className="text-light regular"><small>From today onward, readers can stay up-to-date with news in the most direct ...</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>                    
    
    
        <IconCropper
            open={openCropper} 
            onClose={onCancelCrop} 
            url={imagePath} 
            onSave={getCroppedIcon}
            aspect={512 / 512}
        />
    </>
}

export default ChangeIcon;